export function formatFileSize(bytes) {
  if (bytes === 0) return '0B';
  const k = 1000;
  const sizes = ['B', 'kB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(0))}${sizes[i]}`;
}
